import { map, mapTo, scan } from "rxjs/operators";
export function bufferRecent(count) {
    if (count < 1) {
        return (source) => source.pipe(mapTo([]));
    }
    if (count === 1) {
        return (source) => source.pipe(map((value) => [value]));
    }
    return (source) => source.pipe(scan((acc, value) => [...acc.slice(1 - count), value], []));
}
//# sourceMappingURL=bufferRecent.js.map